import { FAC_FEATURE_ID } from '@bingads-webui-campaign/recommendation-core';
import { Constants as CCUIConstants } from '@bingads-webui-clientcenter/entity-utils';

export const FAC_STATUS = Object.freeze({
  NOT_IN_PROGRESS: CCUIConstants.RecommendationAdoptionStatus.NotInProgess,
  ACTIVE: CCUIConstants.RecommendationAdoptionStatus.Active,
  ADOPTED: CCUIConstants.RecommendationAdoptionStatus.Adopted,
});

export const AUTO_BIDDING_FEATURE_IDS = Object.freeze({
  MAX_CLICKS: parseInt(FAC_FEATURE_ID.AUTO_BIDDING_MAX_CLICKS, 10),
  MAX_CONVERSIONS: parseInt(FAC_FEATURE_ID.AUTO_BIDDING_MAX_CONVERSIONS, 10),
});
